import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { Button, Modal, Typography, Upload } from "antd";
import { RcFile } from "antd/es/upload/interface";
import moment from "moment";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { useWebAppFooterIcons } from "~/Modules/ECMS/CORPORATE/Forms/MainNavigation/MainNavigation.hook";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { fields } from "../../constants";
export const AddEditPassengerSocialMediaIcon = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [currentAirport] = useLocalStorage("currentAirport", null);
  const [uploadModal, setUploadModal] = useState<{
    visible: boolean;
    fieldName?: string;
    file?: RcFile;
    uploading?: boolean;
    setValue?: (name: string, value: string) => void;
  }>({
    visible: false,
    fieldName: undefined,
    file: undefined,
    uploading: false,
  });
  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useWebAppFooterIcons(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const ParentMenuFormConfig: FormConfig = {
    initialValues: {
      name: dataById ? decodeHTML(dataById.payload.name) : editData ? decodeHTML(editData?.name) : "",

      field_footer_logo_name_ms: dataById
        ? decodeHTML(dataById.payload.field_footer_logo_name_ms)
        : editData
          ? decodeHTML(editData?.field_footer_logo_name_ms)
          : "",

      field_footer_logo_name_zh: dataById
        ? decodeHTML(dataById.payload.field_footer_logo_name_zh)
        : editData
          ? decodeHTML(editData?.field_footer_logo_name_zh)
          : "",

      link: dataById ? decodeHTML(dataById.payload.link) : editData ? decodeHTML(editData?.link) : "",

      published: dataById ? dataById.payload.published : editData ? editData.published : false,
      image: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: dataById?.payload?.image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "image.png",
              status: "done",
              url: editData?.image,
            },
          ]),
    },
    fields: fields?.socialMedia?.map((field: any) => {
      if (field.uploadTrigger) {
        return {
          ...field,
          openUpload: (fieldName: string, setValue: (name: string, value: string) => void) => {
            setUploadModal({
              visible: true,
              fieldName,
              setValue,
              file: undefined,
              uploading: false,
            });
          },
          usedFileType: ".pdf",
        };
      }
      return field;
    }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "PASSENGER");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    let dateKeys: any = ["date"];
    for (const key of dateKeys) {
      if (data[key]) {
        data[key] = moment(data[key]).format("DD MMM YYYY");
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Passenger Navigation",
      subModule: "passengerFooter_webAppFooterIcons_socialMedia",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      reviewNotes: reviewNotes,
      airportName: currentAirport,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.id || dataById?.payload?.id }),
        ...data,
        isSocialMedia: true,
        field_is_social_media: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add"} Social Media Icon`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={ParentMenuFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${corporateHost}/api/web-app-footer-logos/${editData?.id || dataById?.payload?.id}` : `${corporateHost}/api/create/web-app-footer-logos`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Footer"
      />
      {/* ------------------- UPLOAD POPUP ------------------- */}
      <Modal
        title="Redirect URL Guide"
        open={uploadModal.visible}
        footer={null}
        onCancel={() => setUploadModal({ ...uploadModal, visible: false, file: undefined })}
        width={520}
      >
        <Typography.Paragraph style={{ marginBottom: 12 }}>
          <ol style={{ margin: 0, paddingLeft: 20 }}>
            <li>
              Use <code>/example</code> for pages within this application.
            </li>
            <li>
              Use a full link for external websites (example: <code>https://example.com</code>).
            </li>
            <li>
              Want to use a file? Click <strong>Upload</strong> and paste the link.
            </li>
          </ol>
        </Typography.Paragraph>

        <Upload.Dragger
          accept="*"
          multiple={false}
          showUploadList={false}
          beforeUpload={(file) => {
            setUploadModal((s) => ({ ...s, file }));
            return false;
          }}
        >
          {uploadModal.file ? (
            <p className="ant-upload-text">{uploadModal.file.name}</p>
          ) : (
            <>
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
              </p>
              <p className="ant-upload-text">Click or drag file here</p>
            </>
          )}
        </Upload.Dragger>

        <div style={{ marginTop: 16, textAlign: "right" }}>
          <Button
            type="primary"
            disabled={!uploadModal.file || uploadModal.uploading}
            onClick={async () => {
              if (!uploadModal.file || !uploadModal.fieldName || !uploadModal.setValue) return;

              setUploadModal((s) => ({ ...s, uploading: true }));

              const formData = new FormData();
              formData.append("upload-file", uploadModal.file);
              formData.append("application", "PASSENGER");

              try {
                const res: any = await post("management/upload-file", formData);
                const url = res?.response?.data;
                if (url) {
                  uploadModal.setValue(uploadModal.fieldName, url);
                  openToast({ content: `File uploaded: ${url}`, type: "success" });
                }
              } catch (e) {
                openToast({ content: "Upload failed", type: "error" });
              } finally {
                setUploadModal({ visible: false, fieldName: undefined, file: undefined, uploading: false });
              }
            }}
          >
            {uploadModal.uploading ? (
              <>
                <LoadingOutlined /> Uploading…
              </>
            ) : (
              "Save"
            )}
          </Button>
        </div>
      </Modal>
    </ContentWrapper>
  );
};
